import TaxiCorporationOrderBillingsListRequest, {
  TaxiCorporationOrderBillingsListQueryParams,
} from "./taxi-corporation-order-billings-list.request";

const createQueryParams = (
  request: TaxiCorporationOrderBillingsListRequest,
): TaxiCorporationOrderBillingsListQueryParams => {
  return {
    limit: request.limit,
    offset: request.offset,
    billingModel: request.billingModel,
    billingType: request.billingType,
    cargoCompany: request.cargoCompany,
    dateSince: request.dateSince,
    dateTo: request.dateTo,
    excludeCargoCompany: request.excludeCargoCompany,
    humanId: request.humanId,
    order: request.order,
    passenger: request.passenger,
    planEntryHumanIds: request.planEntryHumanIds,
    responsibleTaxi: request.responsibleTaxi,
    status: request.status,
  };
};

const taxiCorporationOrderBillingsListRequestFactory = {
  createQueryParams,
};

export default taxiCorporationOrderBillingsListRequestFactory;
